import React from "react";
import "./Get.scss";

const Get = () => {
  return (
    <section id="get3">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="get_header">
              <h5>Ready To Collaborate?</h5>
              <h2>Get In Touch</h2>
              <div className="explore_now">
                <a href="#">contact forester</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Get;
